import { TooltipPosition } from "../TooltipContent.types";

export const getPositionOffsetStyles = (
  position: TooltipPosition,
  offset: number
): {
  paddingTop?: number;
  paddingRight?: number;
  paddingBottom?: number;
  paddingLeft?: number;
} => {
  switch (position) {
    case TooltipPosition.Top:
    case TooltipPosition.TopStart:
    case TooltipPosition.TopEnd: {
      return {
        paddingBottom: offset,
      };
    }
    case TooltipPosition.Right:
    case TooltipPosition.RightStart:
    case TooltipPosition.RightEnd: {
      return {
        paddingLeft: offset,
      };
    }
    case TooltipPosition.Bottom:
    case TooltipPosition.BottomStart:
    case TooltipPosition.BottomEnd: {
      return {
        paddingTop: offset,
      };
    }
    case TooltipPosition.Left:
    case TooltipPosition.LeftStart:
    case TooltipPosition.LeftEnd: {
      return {
        paddingRight: offset,
      };
    }
    default: {
      return {};
    }
  }
};
